import { z } from 'zod';

export const tipoTarefaInputSchema = z.object({
  nome: z.string().trim().min(1, 'Obrigatório').max(150, 'Máximo 150 caracteres'),
  relacaoHora: z
    .number()
    .min(-99.99, 'Mínimo -99,99')
    .max(99.99, 'Máximo 99,99')
    .nullable()
    .optional(),
  ativo: z.boolean().optional(),
});

export type TipoTarefaFormValues = z.infer<typeof tipoTarefaInputSchema>;
